module.exports = __webpack_public_path__ + "static/media/analytics.d7f107e3.png";